var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 4H18.375C18.9054 4 19.4141 4.21071 19.7892 4.58579C20.1643 4.96086 20.375 5.46957 20.375 6V20C20.375 20.5304 20.1643 21.0391 19.7892 21.4142C19.4141 21.7893 18.9054 22 18.375 22H6.375C5.84457 22 5.33586 21.7893 4.96079 21.4142C4.58571 21.0391 4.375 20.5304 4.375 20V6C4.375 5.46957 4.58571 4.96086 4.96079 4.58579C5.33586 4.21071 5.84457 4 6.375 4H8.375M9.375 2H15.375C15.9273 2 16.375 2.44772 16.375 3V5C16.375 5.55228 15.9273 6 15.375 6H9.375C8.82272 6 8.375 5.55228 8.375 5V3C8.375 2.44772 8.82272 2 9.375 2Z",
    stroke: "#096DD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.09ad85a8c34b93163ec4353481f094e7.svg";
export { ForwardRef as ReactComponent };